import 'gleam-shared/tinyFA'
import 'gleam-shared/throttledGA'
import 'gleam-shared/styles/normalize'
import 'help-center/core/styles'

import HelpCenter from 'help-center/components/HelpCenter'
import HELP_CENTER_TYPES from 'help-center/constants/types'

const MOCK_FRAME = {
  url: '/docs',
  type: HELP_CENTER_TYPES.DOCS,
  tabs: [{ url: '/docs' }],
  menus: { mobile_menu: [], desktop_menu: [] },
  selected_tab: '/docs',
  external_tabs: [],
  external_links: { desktop_external_links: [], mobile_external_links: [] }
}

export default function assembleApp(appCreator, sourceFrame = MOCK_FRAME) {
  return appCreator(HelpCenter, { sourceFrame })
}
